import awaitToJs from 'await-to-js'
import {
  SET_ROLES_USER,
  ALERT_COLORS,
  MESSAGE_ERROR,
  ALERT_DELAY,
} from '@App/constantes'
import Fetch from '@App/helpers/fetch'
import { setAlertBox } from '../../actions/snackbar'
import { API_URL } from '@App/configs/rest'

const fetchGetRolesUser = new Fetch()

export const setRolesUser = (roles: any) => {
  return {
    type: SET_ROLES_USER,
    payload: roles,
  }
}

export const getRolesUser = () => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(
      fetchGetRolesUser.get({
        url: `${API_URL}/roles/`,
        params: null,
        headers: {},
      }),
    )

    if (!err && data) {
      dispatch(setRolesUser(data))

      return data
    }

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
  }
}

export const createRole = (body) => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(
      fetchGetRolesUser.post({
        url: `${API_URL}/roles/`,
        body: { title: body.title, value: body.value },
        headers: {
          'content-type': 'application/json',
        },
      }),
    )

    if (!err && data) {
      dispatch(getRolesUser())

      return data
    }

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
  }
}
